import { endPointAccount } from "./base.config";

export const account = {
  checkLogin: `${endPointAccount}/check-login`,
  logout: `${endPointAccount}/logout`,
  getUserByToken: `${endPointAccount}/users/token/:token`,
  changeLanguage: `${endPointAccount}/language`,
}